<template>
  <div>
    <!-- <User>
      <template v-slot:user="{ user }">
        <top-nav v-if="user" :user="user"></top-nav>
      </template>
    </User> -->
    <!-- <top-nav /> -->

    <router-view />
  </div>
</template>
